import { render, staticRenderFns } from "./complianceCommitment.vue?vue&type=template&id=8eb3cc18&scoped=true"
import script from "./complianceCommitment.vue?vue&type=script&lang=js"
export * from "./complianceCommitment.vue?vue&type=script&lang=js"
import style0 from "./complianceCommitment.vue?vue&type=style&index=0&id=8eb3cc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb3cc18",
  null
  
)

export default component.exports